import { render, staticRenderFns } from "./FontSizeAutoAdjustBehaviorEditor.vue?vue&type=template&id=ddfb2902&"
import script from "./FontSizeAutoAdjustBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./FontSizeAutoAdjustBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports